<template>
    <div>
        <ValidationObserver ref="observer">
            <b-row class="mb-2">
                <b-col>
                    <h4 class="ml-2">Add New Asset</h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Asset Category"
                    >
                        <!-- <label for="assetCategory">Asset Category *</label> -->
                        <eb-select
                            id="assetCategory"
                            v-model="assetCategory"
                            :options="assetCategoryOptions"
                            label="text"
                            placeholder="Select Asset Category"
                            @input="fetchAssetType"
                            class="w-100"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Asset Type"
                    >
                        <!-- <label for="assetType">Asset Type *</label> -->
                        <eb-select
                            id="assetType"
                            v-model="assetType"
                            :options="assetTypeOptions"
                            label="text"
                            placeholder="Select Asset Type"
                            @input="fetchAssetList"
                            class="w-100"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Asset Category"
                    >
                        <!-- <label for="assetCategory">Asset Category *</label> -->
                        <eb-select
                            id="assetName"
                            v-model="assetName"
                            :options="assetListOptions"
                            label="text"
                            placeholder="Select Asset"
                            class="w-100"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Quantity"
                    >
                        <CustInput
                            inputType="number"
                            inputId="quantity"
                            lableText="Quantity *"
                            v-model="quantity"
                            class="w-100"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col md="6">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Asset Symbol"
                    >
                        <CustInput
                            inputType="text"
                            inputId="assetSymbol"
                            lableText="Asset Symbol *"
                            v-model="assetSymbol"
                            class="w-100"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
                
                <b-col md="6">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Purchase Price"
                    >
                        <CustInput
                            inputType="number"
                            inputId="purchasePrice"
                            lableText="Purchase Price *"
                            v-model="purchasePrice"
                            class="w-100"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
            </b-row> -->
            <!-- <b-row>
                <b-col md="6">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Purchase Date"
                    >
                        <CustInput
                            inputType="date"
                            inputId="purchaseDate"
                            lableText="Purchase Date*"
                            v-model="purchaseDate"
                            class="w-100"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
            </b-row> -->
            <!-- <b-row>
                <b-col>
                    <ValidationProvider
                        v-slot="{ errors }"
                        name="Additional Notes"
                    >
                        <b-form-textarea
                            id="additionalnotes"
                            v-model="additionalNotes"
                            placeholder="Additional Notes"
                            rows="3"
                            max-rows="4"
                        ></b-form-textarea>
                        <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col>
            </b-row> -->
            <b-row class="pt-3">
                <b-col class="text-right">
                    <b-button
                        class="mr-2"
                        variant="danger"
                        @click="cancelAddAsset"
                    >
                        Cancel
                    </b-button>
                    <b-button variant="success" @click="saveAsset">
                        Save Asset
                    </b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import CustInput from "@/components/Common/CustomInput";
import Loading from "../loading.vue";
import ebSelect from "@/components/FormElements/Select";
import { mapState } from "vuex";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        CustInput,
        ebSelect,
    },
    data() {
        return {
            Loading: false,
            assetCategory: "",
            assetType: "",
            assetName: "",
            assetSymbol: "",
            // purchasePrice: "",
            quantity: "",
            // purchaseDate: "",
            // additionalNotes: "",
        };
    },
    computed: {
        ...mapState({
            assetCategoryDetails: (state) =>
                state.portfolio.assetCategoryDetails,
            assetTypeDetails: (state) => state.portfolio.assetTypeDetails,
            assetList: (state) => state.portfolio.assetList,
            portfolioList: (state) => state.portfolio.portfolioList,
        }),

        assetCategoryOptions() {
            if (
                !this.assetCategoryDetails ||
                !this.assetCategoryDetails.length
            ) {
                return [];
            }
            return this.assetCategoryDetails.map((category) => ({
                text: category.name,
                value: category._id,
            }));
        },
        assetTypeOptions() {
            if (!this.assetTypeDetails || !this.assetTypeDetails.length) {
                return [];
            }
            return this.assetTypeDetails.map((type) => ({
                text: type.name,
                value: type._id,
            }));
        },
        assetListOptions() {
            if (!this.assetList || !this.assetList.length) {
                return [];
            }

            return this.assetList
                .map((asset) => {
                    if (
                        asset.string_attributes &&
                        asset.string_attributes.length > 0
                    ) {
                        return {
                            text: asset.string_attributes[0].attribute_value,
                            value: asset.string_attributes[0].attribute_value,
                            id: asset._id,
                        };
                    }
                    return null;
                })
                .filter((item) => item !== null);
        },
    },
    methods: {
        cancelAddAsset() {
            // Reset store state values to empty arrays
            this.$store.commit("portfolio/assetCategoryData", []);
            this.$store.commit("portfolio/assetTypeData", []);
            this.$store.commit("portfolio/assetListDetails", []);
            this.$emit("cancel");
        },
        async saveAsset() {
            this.loading = true;
            let selectedAsset = this.assetList.find(
                (asset) => asset._id === this.assetName.id
            );
            let payload = {
                customer: {
                    phone: this.portfolioList[0].authentication.phone,
                    name:
                        this.portfolioList[0].name.first +
                        " " +
                        this.portfolioList[0].name.last,
                    email: this.portfolioList[0].authentication.email,
                    tax_registration: "",
                    address_line_1: "",
                    address_line_2: "",
                    city: selectedAsset.Address.City,
                    pincode: "",
                },
                invoiceNumber: 538,
                orderDetails: {
                    paymentType: "COD",
                    items: [
                        {
                            name: selectedAsset.string_attributes[0]
                                .attribute_value,
                            price: selectedAsset.Price,
                            unit_price: selectedAsset.Price,
                            image: selectedAsset.product_summary.images
                                .bigImage,
                            _id: selectedAsset._id,
                            IsIncludingTax: selectedAsset.IsIncludingTax,
                            sellerContact: selectedAsset.sellerContact,
                            IsSellable: selectedAsset.IsSellable,
                            catalogId: selectedAsset.catalogId,
                            provider: selectedAsset.provider,
                            productType: selectedAsset.productType,
                            isDeleted: selectedAsset.isDeleted,
                            description_summary:
                                selectedAsset.description_summary,
                            Type: selectedAsset.Type,
                            itemIndex: selectedAsset.itemIndex,
                            createdAt: selectedAsset.createdAt,
                            isOffline: selectedAsset.isOffline,
                            tenant: selectedAsset.tenant,
                            providerName: selectedAsset.providerName,
                            Category: selectedAsset.Category,
                            Market: selectedAsset.Market,
                            slug: selectedAsset.slug,
                            tags: selectedAsset.tags,
                            updatedAt: selectedAsset.updatedAt,
                            string_attributes: selectedAsset.string_attributes,
                            product_summary: selectedAsset.product_summary,
                            revenue_code: "4010041",
                            final_price: selectedAsset.Price * this.quantity,
                            taxes: [
                                {
                                    tax_code: selectedAsset["Tax code"],
                                    amount: 0,
                                },
                            ],
                            quantity: this.quantity,
                            tax_amount: 0,
                        },
                    ],
                    totalPriceBeforeTax: 12000,
                    discount: 0,
                },
                payment: {
                    type: "COD",
                },
                offlineSaleType: "POS",
            };
            await this.$store.dispatch("portfolio/saveAssetAction", payload);
            this.loading = false;
            this.$emit("cancel");
        },
        async fetchAssetType(e) {
            this.loading = true;
            let payload = {
                category: false,
                catalogId: this.assetCategoryDetails[0]._id,
            };
            await this.$store.dispatch(
                "portfolio/fetchSubCategoriesAction",
                payload
            );
            this.loading = false;
        },
        async fetchAssetList(e) {
            this.loading = true;
            let catalogDomainData = this.$currentUserData;
            const payload = {
                provider: catalogDomainData._id,
                catalogId: e.value,
            };
            await this.$store.dispatch(
                "portfolio/fetchAssetTypeAction",
                payload
            );
            this.loading = false;
        },
    },
    async mounted() {},
};
</script>

<style lang="scss" scoped></style>
